import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  /* flex-direction: column; */
  gap: 0.75rem;
  justify-content: space-between;
  align-items: center;
  /* padding: 1rem; */
  /* background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0.5rem; */
`;

export const BadgeGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
`;

export const BadgeItem = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;
